import { createFileRoute } from "@tanstack/react-router";
import SupportCenter from "@/components/support/SupportCenter";

export const Route = createFileRoute("/partner/support/")({
  component: () => <SupportCenter dashboardPath="/partner/dashboard" />,
});
